import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=b6b81d88&scoped=true"
import script from "./publicity.vue?vue&type=script&lang=js"
export * from "./publicity.vue?vue&type=script&lang=js"
import style0 from "./publicity.vue?vue&type=style&index=0&id=b6b81d88&prod&scoped=true&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b6b81d88",
  null
  
)

export default component.exports